module.exports = __webpack_public_path__ + "cf5933d87ee42a465275137375f2317b.svg";


//////////////////
// WEBPACK FOOTER
// ./resources/sponsors/stagradio.svg
// module id = 50
// module chunks = 0